module.exports = __webpack_public_path__ + "img/lb.lbede59c1.svg";